import { useEffect } from 'react';
import { useMap, useMapsLibrary } from '@vis.gl/react-google-maps';

export const HeatmapLayer = ({ data, maxIntensity, radius = 30, gradient }) => {
  const map = useMap();
  const visualizationLibrary = useMapsLibrary('visualization');

  useEffect(() => {
    if (!map || !visualizationLibrary || !data || data.length === 0) {
      return;
    }

    const heatmap = new visualizationLibrary.HeatmapLayer({
      data: data,
      map: map,
      maxIntensity: maxIntensity,
      radius: radius,
      ...(gradient && { gradient: gradient }),
    });

    return () => {
      heatmap.setMap(null);
    };
  }, [map, visualizationLibrary, data, maxIntensity, radius, gradient]);

  return null;
};
